// @ts-nocheck
import { flow, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils/utils';
import { DutyOffRequest } from './models/DutyOffRequest';
import NotificationToast from '../components/common/NotificationToast';

export interface DutyOffRequestSearchCriteria {
  pharmacyId?: number;
}

export const DutyOffRequestStore = types
  .compose(
    getBaseStore<Instance<typeof DutyOffRequest>, SnapshotIn<typeof DutyOffRequest>>(
      DutyOffRequest,
      'dutyOffRequestId',
      'dutyOffRequest',
    ),
    types.model('DutyOffRequestStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const searchDutyOffRequest = flow(function*(criteria: DutyOffRequestSearchCriteria) {
      const result = yield apiFetcher.get('dutyOffRequest', {
        params: criteria,
      });
      if (result != null) {
        self.putInStore(result);
        // @ts-ignore
        const resultIds = result.map((r) => r.dutyOffRequestId);
        return self.dataList.filter((d) => resultIds.indexOf(d.dutyOffRequestId) >= 0);
      }
      return null;
    });

    const checkDutyOffRequests = flow(function*(year: string) {
      const result = yield env.api.get('dutyOffRequest/checkDutyOffRequests/' + year);
      if (result != null) {
        NotificationToast.showSuccess('DutyOffRequests successfully checked');
      }
      return result;
    });

    const checkPharmacyDutyOffRequests = flow(function*(year: string, apbNumber: string) {
      const result = yield env.api.get('dutyOffRequest/checkDutyOffRequests/' + year + '/pharmacy/' + apbNumber);
      if (result != null) {
        NotificationToast.showSuccess('DutyOffRequests successfully checked');
      }
      return result;
    });

    return {
      searchDutyOffRequest,
      checkDutyOffRequests,
      checkPharmacyDutyOffRequests,
    };
  });
